<template>
  <v-container>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-card
          class="mx-auto d-print-none"
          style="border: darkgreen 2px solid;background-color: linen"
      >
        <v-card-title>
          <v-icon
              large
              left
          >
            mdi-file-edit
          </v-icon>
          <p>จัดโครงการ / จัดเดินทางไปปฏิบัติราชการ(<span
              style="font-weight: bold;color: #ff6d81">{{ appHeaderName }}</span>)</p>
          <v-spacer></v-spacer>
<!--          <v-btn outlined :color="appColor" @click="dialogProcess = true">-->
          <v-btn outlined :color="appColor" @click="$root.$refs.Train.ChooseProcess(TypeProject, true);">
            <span style="font-size: 20px">กลับเมนูหลัก</span>
          </v-btn>
        </v-card-title>

        <v-card-text class="headline font-weight-bold">
        </v-card-text>

        <v-card-actions class="justify-space-around">
         <v-list>
           <v-list-item>
             <v-row
                 class="justify-space-around"
             >
               <v-col align="center" col="12" md="12">
                 <v-btn
                     x-large
                     :outlined="menu.id == HeaderPage"
                     :text="menu.id != HeaderPage"
                     v-for="menu in Menu"
                     :key="menu.id"
                     :disabled="menu.disable"
                     :color="(menu.id == HeaderPage ? '#1E88E5' : '#607D8B')"
                     @click="goToPage(menu, true)">
                   <h3 style="font-weight: bold">{{ menu.value }}</h3>
                 </v-btn>
                 <hr/>
               </v-col>
             </v-row>
           </v-list-item>
           <v-list-item>
             <v-row
                 class="justify-space-around"
             >
               <v-col align="center" col="12" md="12">
                 <template
                     v-for="menu in Menu2"
                 >
                   <v-btn
                       x-large
                       :outlined="menu.id == ManageProjectPage"
                       :text="menu.id != ManageProjectPage"
                       :key="menu.id"
                       :disabled="menu.disable"
                       v-if="(menu.id != '4') || (menu.id == '4' && TypeProject == '1')"
                       :color="(menu.id == ManageProjectPage ? '#1E88E5' : '#607D8B')"
                       @click="goToPage(menu, false)">
                     <h3 style="font-weight: bold">{{ (menu.id == '1' ? TypeProject == '1' ? 'ข้อมูลจัดโครงการ (เบิกงบ, ไม่เบิกงบ)' : 'ข้อมูลจัดอบรม/เดินทางไปปฏิบัติราชการ' : menu.id == '2' ? TypeProject == '1' ? 'จัดโครงการ (เบิกงบ, ไม่เบิกงบ))' : 'จัดอบรม/เดินทางไปปฏิบัติราชการ' : menu.id == '3' ? TypeProject == '1' ? 'แก้ไขข้อมูลจัดโครงการ' : 'แก้ไขข้อมูลจัดเดินทางไปปฏิบัติราชการ' : menu.value) }}</h3>
                   </v-btn>
                 </template>
                 <hr/>
               </v-col>
             </v-row>
           </v-list-item>
         </v-list>
        </v-card-actions>

        <router-view></router-view>

      </v-card>
      <div class="d-none d-print-block">
        <router-view></router-view>
      </div>
    </template>
    <template>
      <v-dialog
          v-model="dialogProcess"
          max-width="1000"
          persistent>
        <v-card>
          <v-card-title>
            <span style="font-weight: bold">
              จัดโครงการ / จัดอบรมหรือเดินทางไปปฏิบัติราชการ
            </span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt12">
            <row class="d-flex justify-center mt-12">
              <v-col
                  cols="12"
                  md="6"
                  class="d-flex justify-center"
              >
                <v-btn class="font-weight-bold pa-12" color="primary" @click="ChooseProcess('1')">
                  <span style="font-size: 20px">โครงการ</span>
                </v-btn>
              </v-col>
              <v-col
                  cols="12"
                  md="6"
                  class="d-flex justify-center"
              >
                <v-btn class="font-weight-bold pa-12" color="#004D40" dark @click="ChooseProcess('2')">
                  <span style="font-size: 20px">อบรม / เดินทางไปปฏิบัติราชการ</span>
                </v-btn>
              </v-col>
            </row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogLoading"
          persistent
          width="300"
      >
        <v-card
            color="primary"
            dark
        >
          <v-card-text>
            Loading.....
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogChooseProcess"
          max-width="800">
        <v-card>
          <v-card-title class="font-weight-bold">
            <span v-if="TypeProject == '1'" style="color: black">โครงการ : เลือกเมนูที่ต้องการทำรายการ</span>
            <span v-else style="color: black">อบรม/เดินทางไปปฏิบัติงาน : เลือกเมนูที่ต้องการทำรายการ</span>
          </v-card-title>
          <v-divider></v-divider>
          <div align="center" class="mt-4 mb-4">
            <v-btn class="ma-2 pa-6" color="#1976d2" dark x-large @click="ChooseProcess('1')">โครงการ</v-btn>
            <v-btn class="ma-2 pa-6" color="#004D40" dark x-large @click="ChooseProcess('2')">อบรม / เดินทาง</v-btn>
          </div>
          <v-divider></v-divider>
          <v-card-text>
            <template v-if="(TypeProject == null || TypeProject == '1')">
              <v-list-item
                    style="background-color: white"
                >
                  <v-list-item-content>
                    <v-btn text x-large  @click="goToPage2('/ManageProject/Project')">
                        <span style="color: black;font-size: 16px;font-weight: bold">ข้อมูลจัดโครงการ (เบิกงบ, ไม่เบิกงบ)</span>
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>
              <v-divider></v-divider>
              <v-list-item
                    style="background-color: white"
                >
                  <v-list-item-content>
                    <v-btn  text x-large  @click="goToPage2('/ManageProject/InsertProject')">
                        <span style="color: black;font-size: 16px;font-weight: bold">จัดโครงการ (เบิกงบ, ไม่เบิกงบ)</span>
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>
              <v-divider></v-divider>
              <v-list-item
                    style="background-color: white"
                >
                  <v-list-item-content>
                    <v-btn text x-large @click="goToPage2('/ManageProject/SettingData')">
                        <span style="color: black;font-size: 16px;font-weight: bold">ตั้งค่าข้อมูล</span>
                    </v-btn>
                  </v-list-item-content>
                </v-list-item>
              <v-divider></v-divider>
            </template>
            <template v-else>
              <v-list-item
                  style="background-color: white"
              >
                <v-list-item-content>
                  <v-btn text x-large  @click="goToPage2('/ManageProject/Project')">
                    <span style="color: black;font-size: 16px;font-weight: bold">ข้อมูลจัดอบรม/เดินทางไปปฏิบัติราชการ</span>
                  </v-btn>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item
                  style="background-color: white"
              >
                <v-list-item-content>
                  <v-btn text x-large @click="goToPage2('/ManageProject/InsertProject')">
                    <span style="color: black;font-size: 16px;font-weight: bold">จัดอบรม/เดินทางไปปฏิบัติราชการ</span>
                  </v-btn>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </template>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark class="font-weight-bold" @click="dialogChooseProcess = false" color="red">
              ปิด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-container>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Const from "@/const/Const";

export default {
  name: "ManageProject",
  data() {
    return {
      dialogChooseProcess: false,
      dialogLoading: false,
      page: null,
      maintain: false,
      dialogProcess: false,
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      CheckAdmin: false,
      CheckSubAdmin: false,
      Menu: [
        {
          id: '0',
          value: 'ขอเสนอแผนอนุมัติงบประมาณประจำปี',
          page: '/Propose_a_plan',
          disable: false
        },
        {
          id: '1',
          value: 'จัดโครงการ / เดินทางไปปฏิบัติราชการ',
          page: '/ManageProject',
          disable: false
        },
        {
          id: '2',
          value: 'เข้าร่วมโครงการ / เดินทางไปปฏิบัติราชการ',
          page: '/JoinProject',
          disable: false
        }
      ],
      Menu2: [
        {
          id: '1',
          value: 'ข้อมูลจัดโครงการ / จัดเดินทางไปปฏิบัติราชการ',
          page: '/ManageProject/Project',
          disable: false,

        },
        {
          id: '2',
          value: 'จัดโครงการ (เบิกงบ, ไม่เบิกงบ)',
          page: '/ManageProject/InsertProject',
          disable: false
        },
        {
          id: '4',
          value: 'ตั้งค่าข้อมูล',
          page: '/ManageProject/SettingData',
          disable: false
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      PermissionAdmin: 'Permission/getPermission',
      MenuPermiss: 'Permission/getMenuPermiss',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      TypeProject: 'Project/getTypeProject',
      HeaderPage: 'Project/getHeaderPage',
      ManageProjectPage: 'Project/getManageProjectPage',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      getMenuPermissData: 'Permission/getMenuPermissData',
      getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
      changeTypeProject: 'Project/changeTypeProject',
      changeHeaderPage: 'Project/changeHeaderPage',
      changeManageProjectPage: 'Project/changeManageProjectPage',
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
    }),
    goToPage: function (param, checkMenu) {
      if (checkMenu) {
        this.changeHeaderPage({
          page: param.id
        })
        this.changeManageProjectPage({
          page: null
        })
      } else {
        this.changeHeaderPage({
          page: this.HeaderPage
        })
        this.changeManageProjectPage({
          page: param.id
        })
      }
      this.$router.push(param.page)
    },
    goToPage2: function (param) {
      this.$router.push(param)
      this.dialogChooseProcess = false
    },
    ChooseProcess(page) {
      this.page = null
      this.page = page
      this.changeHeaderPage({
        page: '1'
      })
      this.changeManageProjectPage({
        page: null
      })
      if (page == '1') {
        this.changeTypeProject({
          type: '1'
        })
        this.changeColor({
          color: '#1976d2'
        })
        this.changeHeaderName({
          headerName: Const.defaultHeaderApp1
        })
        this.$router.push('/ManageProject')
        this.dialogProcess = false
      } else {
        this.changeTypeProject({
          type: '2'
        })
        this.changeColor({
          color: '#004D40'
        })
        this.changeHeaderName({
          headerName: Const.defaultHeaderApp2
        })
        this.$router.push('/ManageProject')
        this.dialogProcess = false
      }
      this.dialogChooseProcess = true
    }
  },
  mounted() {
    this.changeHeaderPage({
      page: '1'
    })
    this.changeManageProjectPage({
      page: null
    })
    this.changeColor({
      color: Const.defaultColorApp
    })
    this.changeHeaderName({
      headerName: Const.defaultHeaderApp
    })
    if (this.TypeProject == null) {
      this.changeTypeProject({
        type: '1'
      })
    }
    this.dialogLoading = true
    this.dialogChooseProcess = true
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '8'
        })
        this.getPermissionData({
          perid: this.MeData[0].perid
        }).then(resAdmin => {
          if (resAdmin) {
            this.PermissionAdmin.map((Per_i, idx) => {
              if (Per_i.permission_id == '9000') {
                this.getMenuPermissData().then(res => {
                  if (res) {
                    if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '8' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                      this.maintain = false
                      this.TypeProject == null ? this.dialogProcess = true : this.ChooseProcess(this.TypeProject)
                    } else {
                      this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '8' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '8')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                      this.maintain = true
                    }
                  }
                }).then(err => {
                  if (err) {
                    this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '8' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '8')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                    this.maintain = true
                  }
                })
                this.CheckAdmin = true
                this.dialogLoading = false
              } else {
                if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                  this.dialogLoading = false
                  this.$router.push('/')
                }
              }
            })
          } else {
            this.getPermissionUserData({
              perid: this.MeData[0].perid
            }).then(resUser => {
              if (resUser) {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '9000') {
                    this.getMenuPermissData().then(res => {
                      if (res) {
                        if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '8' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                          this.maintain = false
                          this.TypeProject == null ? this.dialogProcess = true : this.ChooseProcess(this.TypeProject)
                        } else {
                          this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '8' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '8')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                          this.maintain = true
                        }
                      }
                    }).then(err => {
                      if (err) {
                        this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '8' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '8')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                        this.maintain = true
                      }
                    })
                    this.CheckSubAdmin = true
                    this.dialogLoading = false
                  } else {
                    if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                      this.dialogLoading = false
                      this.$router.push('/')
                    }
                  }
                })
              } else {
                this.CheckSubAdmin = false
                this.CheckAdmin = false
                this.dialogLoading = false
                this.$router.push('/')
              }
            })
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>

</style>
